import React from 'react';
import IntentionsStatisticsRoutes from './IntentionsStatisticsRoutes';
import { useTracking } from 'react-tracking';
import { useDispatch, useSelector } from 'react-redux';
import { startRegisterTrackingHistory } from '../../app/actions/trackingHistoryActions';

const IntentionsStatisticsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: 'Statistics',
      page: 'Intentions Statistics Screen',
      user_id: user.user_id,
      user_name: user.user_name,
    },
    {
      dispatch: (data) => {
        dispatch(startRegisterTrackingHistory(data));
      },
    }
  );

  return (
    <div>
      <Track>
        <IntentionsStatisticsRoutes />
      </Track>
    </div>
  );
};

export default IntentionsStatisticsScreen;
